module.exports = __webpack_public_path__ + "static/media/forum.e320c73b.svg";